import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80v352c0 26.5-21.5 48-48 48h-85.3v-177.2h60.6l8.7-67.6h-69.3v-43.2c0-19.6 5.4-32.9 33.5-32.9h35.8v-60.4c-6.2-0.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9h-60.8v67.6h60.9v177.1h-196.9c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/facebook-square.js
// module id = null
// module chunks = 